// extracted by mini-css-extract-plugin
module.exports = {"container":"Vacancies_container__3XOSN","work":"Vacancies_work__1Fvtp","vacancy":"Vacancies_vacancy__DjV_8"};